import { render, staticRenderFns } from "./AdminRemote.vue?vue&type=template&id=44e5e408"
import script from "./AdminRemote.vue?vue&type=script&lang=js"
export * from "./AdminRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AdminRemote.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports